function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff"
}, React.createElement("circle", {
  cx: 552,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 533,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 514,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 504.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 495.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 485.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 485.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 476.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 476.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 466.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 466.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 466.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 466.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 466.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 457.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 457.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 447.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 447.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 447.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 447.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 438.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 438.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 438.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 428.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 428.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 428.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 428.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 428.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 428.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 419.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 419.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 419.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 419.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 419.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 409.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 409.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 409.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 409.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 409.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 390.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 390.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 390.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 390.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 381.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 371.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 371.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 371.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 371.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 362.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 362.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 362.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 362.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 352.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 343.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 343.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 343.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 343.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 333.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 333.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 333.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 333.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 333.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 333.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 333.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 324.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 324.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 324.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 324.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 314.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 314.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 314.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 314.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 314.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 305.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 305.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 305.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 305.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 305.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 305.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 295.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 295.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 295.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 295.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 295.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 295.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 286.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 286.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 286.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 286.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 286.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 286.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 276.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 276.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 276.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 276.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 267.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 257.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 257.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 248.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 238.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 238.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 229.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 229.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 219.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 219.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 219.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 219.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 219.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 219.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 210.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 200.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 200.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 191.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 191.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 191.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 191.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 191.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 181.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 172.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 172.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 172.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 172.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 172.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 162.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 162.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 153.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 153.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 153.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 143.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 134.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 134.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 134.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 134.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 124.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 115.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30,
  cy: 62,
  r: 30,
  opacity: 0.03
}));

var SvgCountryFigures02 = function SvgCountryFigures02(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 582 124",
    style: {
      backgroundColor: "#0d5b61"
    }
  }, props), _ref);
};

export default SvgCountryFigures02;